<template>
	<div class="">
		<b-navbar toggleable="md" type="dark" variant="info" class="bg-integreat">
	      <b-container class="justify-content-center">
	        <b-navbar-brand to="/signin" class="font-30">
	          <!-- Integreat -->
						<b-img  :src="require('@/assets/img/integreatLogo.png')" fluid alt="Responsive image"></b-img>
	        </b-navbar-brand>
	      </b-container>
	    </b-navbar>
	    <div class="container">
    	
		<form @submit.prevent="submit()" class="text-left signinmentor border rounded py-4 px-5 mt-5 col-8 mx-auto" >
			<div v-if="loginError" class="alert alert-danger text-center" role="alert" :class="{'shake animated': animated}">
	          {{textError}}
	        </div>
	        <b-form-group id="input-group-email" label="E-mail"  label-for="input-email">
	            <b-form-input
	                id="input-email"
	                type="email"
	                required
	                v-model="email"
	                placeholder="example@gmail.com"
	            ></b-form-input>
	        </b-form-group>

	        <b-form-group id="input-group-2" label="Password" label-for="input-password">
	            <b-form-input
	                id="input-password"
	                type="password"
	                required
	                 v-model="password"
	                placeholder="Password"
	            ></b-form-input>
	        </b-form-group>
	        <b-button 
	        type="submit"
	            block 
	            pill 
	            variant="outline-primary" 
	            class="btn-sigin bg-integreat my-2  not-shadow-active opacity">
	            SIGN IN</b-button>
    	</form>
    	</div>
	</div>
</template>
<script>
import {HTTPTICKET,HTTPMentor} from "@/axios.js";
	export default{
		data () {
		    return {
		      loading:false,
	          email:'',
	          textError:'',
	          password:'',
	          loginError:false,
		      mentor:{
		          email:'',
		          password:'',
		      },
			  signinmentor:false,
			  animated:false
		    }
		},
		methods:{
			submit(){
				let data ={
					email:this.email,
					password:this.password,
					projectCode:"QSvp2Hk-8rlHPu8",
					redirectUrl:""
				}
				HTTPTICKET.post('/api/login/export',data).then(res =>{
					console.log('/api/login/export',res)
					if(res.data.success){
					this.$store.commit('setUser',res.data.obj.objUser)
						let data ={
							key:'token',
							value:res.data.tokenAuth
						}
						this.$store.commit('updateUser',data)
					 this.$router.push("/");
					}else{
						if(res.data.data == "user is not access."){
							this.textError = "Sorry for your inconvenience :( We're not allowed mentor access to this page."
						}else{
							this.textError = "Invalid E-mail or password"
						}
						this.animated = true
						setTimeout(() => {
						this.animated = false
						},1000)
						this.loginError = true
	                    setTimeout(()=>{
	                      this.loginError = false
	                    },5000)
					}
				}).catch(e =>{
					console.log(e)
				})
			}
		}
	}
</script>
<style scoped>
.bg-integreat{
	background: linear-gradient(179.25deg, #9356E0 -19.35%, #6D8DF3 137.86%);
}
</style>



// WEBPACK FOOTER //
// src/components/SigninIntegreat.vue